import { ReactNode } from 'react';

const _DiaryShortsFooter = ({ children }: { children: ReactNode }) => {
  return (
    <div className="fixed inset-x-0 bottom-0">
      <div className="h-16px w-full bg-gradient-to-t from-black/80 to-transparent" />
      <div className="bg-black/80 px-16px pb-16px">{children}</div>
    </div>
  );
};

export default _DiaryShortsFooter;
